import { isEmpty, uniq } from "ramda";
import { FC, useCallback } from "react";
import { useTranslate } from "react-admin";

import { getErrorMessage } from "../utils/errors";
import ErrorMessage from "./ErrorMessage";

const ErrorListing: FC<any> = ({ errors }) => {
  const translate = useTranslate();

  const getErrorMessages = useCallback((errors) => {
    return !isEmpty(errors) ? uniq(Object.keys(errors).map((key) => getErrorMessage(errors[key], key, translate))) : [];
  }, []);

  return (
    <>
      {getErrorMessages(errors).map((message) => (
        <ErrorMessage key={message} text={message} />
      ))}
    </>
  );
};

export default ErrorListing;
